import { PAGES } from "constants/pages";

import inspectMasterImage from "assets/images/pages/case-studies/InspectMaster-CaseStudy.jpg";
import financialEngineImage from "assets/images/pages/case-studies/FinancialEngine-CaseStudy.jpg";
//import travelMasterImage from "assets/images/jpg/TravelMaster-CaseStudy.jpg";
import haaWhiteLabelImage from "assets/images/pages/case-studies/HAAWhiteLabel-CaseStudy.jpg";
import biHealthcareSolutionImage from "assets/images/pages/case-studies/BIHealthcareSolution-CaseStudy.jpg";
import aiAnomalyImage from "assets/images/pages/case-studies/aiAnomaly-CaseStudy.jpg";
import medullaImage from "assets/images/pages/case-studies/TransformingChiropractic-CaseStudy.jpg";
import slichka from "assets/images/pages/case-studies/Slichka-CaseStudy.jpg";
import i18next from "i18next";

export const caseStudies = [
  {
    name: "Inspect Master",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item1.header"),
    image: inspectMasterImage,
    imageOptions: {
      position: "center right",
      height: "215px",
    },
    text: i18next.t("ourWorkPage.challengeToSolution.items.item1.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item1.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item1.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item1.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item1.rate.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item1.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item1.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item1.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item1.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item1.location"),
    isInHouseProject: true,
    biggerPadding: true,
    link: PAGES.CASE_STUDY_INSPECT_MASTER.route,
  },
  {
    name: "Financial Engine",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item2.header"),
    image: financialEngineImage,
    imageOptions: {
      position: "left",
      height: "215px",
    },
    text: i18next.t("ourWorkPage.challengeToSolution.items.item2.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item2.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item2.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item2.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item2.rate.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item2.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item2.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item2.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item2.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item2.location"),
    isInHouseProject: false,
    link: PAGES.CASE_STUDY_FINANCIAL_ENGINE.route,
  },
  {
    name: "HAA White Label",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item3.header"),
    image: haaWhiteLabelImage,
    width: "449.5px",
    imageOptions: {
      position: "center",
      height: "215px",
      bgSize: "cover",
    },
    text: i18next.t("ourWorkPage.challengeToSolution.items.item3.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item3.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item3.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item3.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item3.rate.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item3.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item3.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item3.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item3.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item3.location"),
    isInHouseProject: false,
    link: PAGES.CASE_STUDY_HAA.route,
  },
  {
    name: "AI Anomaly Detection",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item4.header"),
    image: aiAnomalyImage,
    imageOptions: {
      position: "top left",
      height: "215px",
      bgSize: "cover",
    },
    width: "439.5px",
    text: i18next.t("ourWorkPage.challengeToSolution.items.item4.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item4.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item4.users.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item4.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item4.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item4.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item4.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item4.location"),
    isInHouseProject: true,
    smallPaddingBigger: true,
    link: PAGES.CASE_STUDY_AI_ANOMALY_DETECTION.route,
  },
  {
    name: "BI Healthcare Solution",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item5.header"),
    image: biHealthcareSolutionImage,
    imageOptions: {
      position: "bottom",
      height: "250px",
      bgSize: "cover",
    },
    width: "449.5px",
    text: i18next.t("ourWorkPage.challengeToSolution.items.item5.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item5.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item5.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item5.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item5.rate.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item5.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item5.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item5.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item5.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item5.location"),
    isInHouseProject: false,
    link: PAGES.CASE_STUDY_BI_HEALTHCARE_SOLUTION.route,
  },
  {
    name: "Transforming Chiropractic",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item6.header"),
    image: medullaImage,
    imageOptions: {
      position: "left",
      height: "440px",
      bgSize: "cover",
    },
    width: "449.5px",
    text: i18next.t("ourWorkPage.challengeToSolution.items.item6.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item6.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item6.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item6.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item6.rate.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item6.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item6.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item6.location"),
    isInHouseProject: false,

    imgHeight: "285px",
    link: PAGES.CASE_STUDY_MEDULLA.route,
  },
  {
    name: "Slichka",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item7.header"),
    image: slichka,
    imageOptions: {
      position: "center right",
      height: "215px",
    },
    text: i18next.t("ourWorkPage.challengeToSolution.items.item7.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.rate.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item7.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item7.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item7.location"),
    isInHouseProject: true,
    biggerPadding: false,
    link: PAGES.CASE_STUDY_SLICHKA.route,
  },
  /*  {
    name: "TravelMaster",
    header: i18next.t("ourWorkPage.challengeToSolution.items.item7.header"),
    image: travelMasterImage,
    width: "449.5px",
    imgSmall: true,
    text: i18next.t("ourWorkPage.challengeToSolution.items.item7.text"),
    radius: true,
    users_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.users.number"
    ),
    users_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.users.label"
    ),
    rate_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.rate.number"
    ),
    rate_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.rate.label"
    ),
    yearsInUse_number: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.yearsInUse.number"
    ),
    yearsInUse_label: i18next.t(
      "ourWorkPage.challengeToSolution.items.item7.yearsInUse.label"
    ),
    category: i18next.t("ourWorkPage.challengeToSolution.items.item7.category"),
    industry: i18next.t("ourWorkPage.challengeToSolution.items.item7.industry"),
    location: i18next.t("ourWorkPage.challengeToSolution.items.item7.location"),
    isInHouseProject: true,
    link: PAGES.CASE_STUDY_BI_HEALTHCARE_SOLUTION.route,
  },*/
];
